export const PATIENT_SEARCH_GET_LIST = '/company/patients'

export const PATIENTS = '/company/patients'

export const PATIENT_SEARCH_DEFAULT_SORT = {
  sortedColumn: 'fullName',
  sortedColumnOrder: 'ascend'
}
